import { ReactNode } from 'react';
import styles from './ScreenReaderOnlyText.module.scss';

interface ScreenReaderOnlyTextProps {
  children: ReactNode;
}

export const ScreenReaderOnlyText = ({ children }: ScreenReaderOnlyTextProps) => {
  return <span className={styles.srOnly}>{children}</span>;
};
